import {Text} from '~/components';
import {DATA_TEST_IDS} from '~/lib/const';
import {Product} from '@shopify/hydrogen/storefront-api-types';

interface ProductWithMainSku extends Product {
  mainSku?: {
    value: string;
  };
}

export const ProductSKUContainer = ({
  product,
}: {
  product: ProductWithMainSku;
}) => {
  const sku = product?.mainSku?.value ?? '';
  const isEmpty = !sku;

  return (
    <Text
      testid={DATA_TEST_IDS.SKU_CONTAINER}
      as="span"
      className="text-14/20 md:text-16/20 font-header font-normal text-gray-600 mt-1"
    >
      {isEmpty ? ' ' : `SKU ${sku}`}
    </Text>
  );
};
